import Vue from "vue";
import Buefy from "buefy";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleLeft,
  faAngleRight,
  faArrowUp,
  faAngleDown,
  faBookReader,
  faColumns,
  faCog,
  faChalkboardTeacher,
  faCheck,
  faChevronRight,
  faEnvelope,
  faExclamationCircle,
  faVolumeMute,
  faVolumeDown,
  faMicrophone,
  faMicrophoneSlash,
  faMicrophoneAltSlash,
  faRedo,
  faTimes,
  faUser,
  faUserEdit,
  faUserCircle,
  faVideo,
  faVideoSlash,
  faCalendarAlt,
  faUserFriends,
  faAddressBook,
  faPlusCircle,
  faClock,
  faSort,
  faTrash,
  faInfoCircle,
  faLock,
  faLockOpen,
  faCaretDown,
  faChevronCircleDown,
  faChevronCircleRight,
  faShareAlt,
  faPhone,
  faHandPaper,
  faSignOutAlt,
  faListUl,
  faSync,
  faSearch,
  faSlidersH
} from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import SlideUpDown from "vue-slide-up-down";
import VueParticles from "vue-particles";

import VueMoment from 'vue-moment';
import moment from 'moment-timezone'

moment.locale('vi')

Vue.use(VueMoment, {
  moment,
})

Vue.use(VueParticles);

// inline svg for font awesome
library.add(
  faAngleLeft,
  faAngleRight,
  faArrowUp,
  faAngleDown,
  faBookReader,
  faColumns,
  faCog,
  faChalkboardTeacher,
  faCheck,
  faChevronRight,
  faEnvelope,
  faExclamationCircle,
  faVolumeMute,
  faVolumeDown,
  faMicrophone,
  faMicrophoneSlash,
  faMicrophoneAltSlash,
  faRedo,
  faTimes,
  faUser,
  faUserEdit,
  faUserCircle,
  faVideo,
  faVideoSlash,
  faFacebookF,
  faTwitter,
  faCalendarAlt,
  faUserFriends,
  faAddressBook,
  faPlusCircle,
  faClock,
  faSort,
  faTrash,
  faInfoCircle,
  faLock,
  faLockOpen,
  faCaretDown,
  faChevronCircleDown,
  faChevronCircleRight,
  faShareAlt,
  faPhone,
  faHandPaper,
  faSignOutAlt,
  faListUl,
  faSync,
  faSearch,
  faSlidersH
);
Vue.component("vue-fontawesome", FontAwesomeIcon);
Vue.use(Buefy, {
  defaultIconComponent: "vue-fontawesome",
  defaultIconPack: "fas"
});

// slide up down
Vue.component("slide-up-down", SlideUpDown);

import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);